export default "__VITE_ASSET__B91Qv$wk__"